export const RETURN_URL_KEY = 'dash_login_return_url';

export function isLogoutLandingUrl(href, origin) {
    try {
        const parsed = new URL(href, origin);
        return parsed.pathname === '/' && new URLSearchParams(parsed.search).has('logout');
    } catch {
        return true;
    }
}

export function normalizeReturnUrl(url, origin) {
    if (!url) {
        return null;
    }
    try {
        const parsed = new URL(url, origin);
        if (parsed.origin !== origin) {
            return null;
        }
        if (isLogoutLandingUrl(parsed.href, origin)) {
            return null;
        }
        return parsed.href;
    } catch {
        return null;
    }
}

/** Save the current URL so we can redirect back after login. */
export function saveReturnUrl() {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        const {href, origin} = window.location;
        if (isLogoutLandingUrl(href, origin)) {
            return;
        }
        sessionStorage.setItem(RETURN_URL_KEY, href);
    } catch {
        // sessionStorage not available
    }
}

/** Consume and return the saved return URL (removes it from storage). */
export function consumeReturnUrl() {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const url = sessionStorage.getItem(RETURN_URL_KEY);
        sessionStorage.removeItem(RETURN_URL_KEY);
        return normalizeReturnUrl(url, window.location.origin);
    } catch {
        return null;
    }
}

export const LOGOUT_REASON_MESSAGES = {
    'service-restart': 'DASH was restarted. Please sign in again to continue where you left off.',
    'collab-reset': 'Your session ended because the collaboration server reset. Please sign in again.',
};

export function getLogoutMessage(reason) {
    return LOGOUT_REASON_MESSAGES[reason] || 'You have been signed out.';
}
